var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-wrap"},[_c('div',{ref:"content",staticClass:"sub",attrs:{"id":`sub-${_vm.uuid}`}}),_c('b-tooltip',{attrs:{"target":`sub-${_vm.uuid}`,"variant":"primary","triggers":"hover","placement":"bottom"}},[_vm._v(" Sub: "+_vm._s(_vm.node.attrs.alias)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }